import {useHistory, useLocation} from 'react-router';

export const useCompleteLocation = useLocation;
export const useHistoryOriginal = useHistory;
